import React from 'react';
import { ShowChangesList, formatListData, EMPTY_ARRAY } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES, ChangesVersionHistory } from 'constant';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _filter from 'lodash/filter';

import { useDataFormatter, requiredKeysList } from './helper';

const useShowChanges = () => {
	const location = useLocation();

	const { bannerHistoryFormatter } = useDataFormatter();
	const getAbTestVersionChangesData = () => {
		const data: ChangesVersionHistory[] = _get(location, ['state', 'rowData', 'changes'], EMPTY_ARRAY);

		const filteredData = _filter(data, (rowData) => requiredKeysList.includes(rowData.key));

		return {
			rowCount: filteredData?.length,
			data: formatListData(filteredData, '_id', bannerHistoryFormatter)
		};
	};

	return { getAbTestVersionChangesData };
};
const ShowChanges: React.FC<{}> = () => {
	const { getAbTestVersionChangesData } = useShowChanges();
	return (
		<ShowChangesList
			getShowChangesData={getAbTestVersionChangesData}
			entity={LIST_ENTITY_NAMES.BANNERS}
			usePageActions={useDashboardActions}
		/>
	);
};

export default ShowChanges;
